import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Spinner } from "@chakra-ui/react";
import { CleanFiltersIcon } from "~misc/icons";
import Select from "~components/Form/components/Select";
import useGrupoProduto from "~/fetchs/useGrupoProdutoV2";
import { getStoragekeysRules } from "~pages/PricesTableV2/helpers/storage";
import { useFormContext, Controller } from "react-hook-form";
import useGrupoSegmento from "~fetchs/useGrupoSegmento";
import useFamiliaProdutoPrecoRegra from "~fetchs/useFamiliaProdutoPrecoRegra";

const FiltroPrazo = ({ filtrosDisponiveis, nomeDoFiltro, loading }) => {
  const { watch, control, reset } = useFormContext();

  const watchGrupoProduto = watch("grupoProduto");

  const { gruposSegmentoPrazoDisponiveis, grupoMaterialDisponiveis, familiasPrazoDisponiveis } = filtrosDisponiveis;

  const optionDefault = useMemo(() => ({ label: "Todos", value: 0 }), []);
  const optionDefaultLoading = useMemo(
    () => ({
      label: loading ? "Carregando..." : optionDefault.label,
      value: optionDefault.value,
    }),
    [loading, optionDefault]
  );

  const keys = useMemo(() => getStoragekeysRules(nomeDoFiltro), [nomeDoFiltro]);

  const { optionGruposProduto } = useGrupoProduto({
    camposOpt: ["nome"],
    gruposDisponiveis: grupoMaterialDisponiveis,
  });

  const { optionFamiliasProduto } = useFamiliaProdutoPrecoRegra({
    familiaProdutoReplicacaoId: "familiaProdutoReplicacaoId",
    grupoProduto: watchGrupoProduto,
    familiasDisponiveis: familiasPrazoDisponiveis,
  });

  const { optionsGrupoSegmento } = useGrupoSegmento({ grupoSegmentoDisponiveis: gruposSegmentoPrazoDisponiveis });

  const clear = () => {
    Object.values(keys).forEach((key) => {
      localStorage.removeItem(key);
    });

    reset({
      grupoProduto: 0,
      grupoSegmento: 0,
      familia: 0,
    });
  };

  const optGruposProduto = useMemo(
    () => [optionDefaultLoading, ...optionGruposProduto],
    [optionDefaultLoading, optionGruposProduto]
  );

  const optGrupoSegmento = useMemo(
    () => [optionDefaultLoading, ...optionsGrupoSegmento],
    [optionDefaultLoading, optionsGrupoSegmento]
  );
  const optFamilia = useMemo(
    () => [optionDefaultLoading, ...optionFamiliasProduto],
    [optionDefaultLoading, optionFamiliasProduto]
  );

  return (
    <>
      <section className="container prices-table-filter">
        <div className="form grid grid-cols-3 gap-x-3">
          <Controller
            name="grupoProduto"
            control={control}
            render={({ field }) => (
              <Select
                label="Grupo de Materiais:"
                options={optGruposProduto}
                spacingControl={true}
                onChange={(selectedOption) => {
                  field.onChange(selectedOption.value);
                  localStorage.setItem(keys.grupoProduto, JSON.stringify(selectedOption));
                }}
                isDisabled={loading}
                loading={loading}
                value={optGruposProduto.find((option) => option.value === field.value) || optionDefault}
              />
            )}
          />

          <Controller
            name="familia"
            control={control}
            render={({ field }) => (
              <Select
                label="Familia de Produto:"
                options={optFamilia}
                spacingControl={true}
                onChange={(selectedOption) => {
                  field.onChange(selectedOption.value);
                  localStorage.setItem(keys.familia, JSON.stringify(selectedOption));
                }}
                isDisabled={loading}
                loading={loading}
                value={optFamilia.find((option) => option.value === field.value) || optionDefault}
              />
            )}
          />

          <Controller
            name="grupoSegmento"
            control={control}
            render={({ field }) => (
              <Select
                label="Grupo Segmento:"
                options={optGrupoSegmento}
                onChange={(selectedOption) => {
                  field.onChange(selectedOption.value);
                  localStorage.setItem(keys.segmento, JSON.stringify(selectedOption));
                }}
                value={optGrupoSegmento.find((option) => option.value === field.value) || optionDefault}
                spacingControl={true}
                isDisabled={loading}
                loading={loading}
              />
            )}
          />

          <div className="col-span-3 flex ml-auto">
            <button type="button" className="clear-filter cursor-pointer" onClick={clear}>
              <span className="desc ml-0 mr-2 cursor-pointer">Limpar Filtros</span>
              <CleanFiltersIcon />
            </button>
          </div>
        </div>
      </section>

      <div className="container">
        <div className="flex">
          {loading && (
            <p className="flex items-start gap-2 text-sm mt-4">
              <Spinner size={"sm"} />
              Verificando se há atualizações nas requisições
            </p>
          )}
        </div>
      </div>
    </>
  );
};

FiltroPrazo.propTypes = {
  filtrosDisponiveis: PropTypes.object,
  nomeDoFiltro: PropTypes.string,
  loading: PropTypes.bool,
};

export default FiltroPrazo;
